import React from 'react';

import PriceTabs from './molecules/PriceTabs';
import StickyFooter from './molecules/StickyFooter';
import Typography from '~lib/frontend/design-system/components/Typography';
import useContentAsset from '~lib/frontend/hooks/use-content-asset';
import useContentKey from '~lib/frontend/hooks/use-content-key';
import { GetterType } from '~lib/frontend/types/content';
import SplitUI, { ContentContainer } from '~website/components/SplitUI';
import HeaderBar from '~website/features/quote/components/molecules/headers/HeaderBar';
const SamplePrices: React.FC = () => {
	const splashImage = useContentAsset('website_core', 'quote/quote_column.svg');

	const g = useContentKey('strings');
	const get: GetterType = (key, fallback) => g(`prelogin.indicative_price.${key}`, fallback);

	const fallbackTitle = 'Our prices';
	const fallbackDisclaimer =
		'Price paid by 10% of customers. Your price will be based on factors like your age, vehicle, and location. Terms apply.';

	return (
		<SplitUI splashImage={splashImage}>
			<HeaderBar sticky />

			<ContentContainer>
				<Typography
					$type={'Heading.Small'}
					$color={'textOnSurfaceBackground'}
					$align={'center'}
					$marginTop={'extraLarge'}
					$marginBottom={'large'}
				>
					{get('title', fallbackTitle)}
				</Typography>

				<PriceTabs />

				<Typography
					$type={'Body.XSmall'}
					$color={'textOnSurfaceBackgroundMuted'}
					$marginTop={'extraLarge'}
					$marginBottom={'extraLarge'}
				>
					{get('disclaimer', fallbackDisclaimer)}
				</Typography>

				<StickyFooter />
			</ContentContainer>
		</SplitUI>
	);
};

export default SamplePrices;
